var storagehandler = function (verb, key, value) {
    var version = "1.5";
    var data;
    switch (verb) {
        case "load":
            if (storagehandler("check")) {
                var pure = localStorage.getItem(key);
                if (pure != undefined) {
                    try {
                        data = JSON.parse(pure);
                        if (data.version === version) {
                            return data.content;
                        }
                    } catch (e) {
                        return undefined;
                    }
                }
            }
            return undefined;
        case "save":
            if (storagehandler("check")) {
                if (value != undefined) {
                    data = { version: version, content: value };
                    localStorage.setItem(key, JSON.stringify(data));
                }
            }
            return undefined;
        case "remove":
            if (storagehandler("check")) {
                localStorage.removeItem(key);
            }
            return undefined;
        case "check":
            var test = "localstorageTest";
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch (e) {
                return false;
            }
    }
    return undefined;
};